import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SelectMedArbetare from "../../../SkapaMote/Inputs/SelectMedArbetare";
import SelectMultiInbjuda from "../../../SkapaMote/Inputs/SelectMultiInbjuda";
import SelectMultiMedArbetare from "../../../SkapaMote/Inputs/SelectMultiMedArbetare";
import HasTeamInput from "../../../SkapaMote/Inputs/HasTeamInput";
import InViteKontaktInput from "../../../SkapaMote/Inputs/InViteKontaktInput";
import BjudaFrom from "../../../SkapaMote/Inputs/BjudaFrom";
import Divider from "@material-ui/core/Divider";
import {isUndefined} from 'lodash'
import {useSelector} from 'react-redux'
import {FormControlLabel,Switch,Typography,TextField } from '@material-ui/core'
import { injectIntl } from 'react-intl';
import IntlMessages from 'util/IntlMessages';
/*
const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));
*/
function Ansvarig(props) {
    const Flags = useSelector(state=>state.accountsData.Flags)
    const SMSPlaceholder = props.intl.formatMessage({ id: 'SMS.Placeholder' });
    return (
        <div>
            <div style={{ paddingTop: '5px' }} className="row">
                <div className="col-12 my-2"  style={{ height: 'auto' }}>
                    <SelectMedArbetare
                    Ansvarig={props.ansvarig}
                    onchangeHanelansvarig={props.onchangeHanelansvarig}                    
                    />
                </div>
                {
                    parseInt(props.userRole) === 4 || parseInt(props.CanSeeInviteFrom) === 1?
                    <div className="col-12 my-2"  style={{ height: 'auto' }}>
                    <SelectMedArbetare
                    MoteBokare="1"
                    Ansvarig={props.MotUser}
                    onchangeHanelansvarig={props.onchangeHanelMotUser}                    
                    />
                </div>
                    :""
                }
                <div className="col-12 my-1">
                    <Divider />
                </div>
                {
                     parseInt(props.userRole) === 4 || parseInt(props.CanSeeInviteFrom) === 1?
                    <>
                    <div className="col-8 my-2"  style={{ height: 'auto'}}>
                        <BjudaFrom
                         InViteFrom={props.InViteFrom}
                         onchangeHandle={props.onchangeHanelInViteFrom} 
                        />
                    </div>
                    <div className="col-4 my-2"  style={{ height: 'auto'}}>
                        <InViteKontaktInput
                        InViteKontakt={props.InViteKontakt}
                        onchangeHandle={props.onchangeHanelInViteKontakt}
                        />
                    </div>
                    <div className="col-12 my-1">
                        <Divider />
                    </div>
                    </>
                    :""
                }
                <div className="col-8 my-2"  style={{ height: 'auto' }}>
                { parseInt(props.HasOutlook)===0?
                     <SelectMultiMedArbetare
                     MedArbetare={props.MedArbetare}
                     onchangeHanelMedArbetare={props.onchangeHanelMedArbetare}
                     //isFrom={1}
                     />
                    :
                    <SelectMultiInbjuda
                    MedArbetare={props.MedArbetare}
                    KontaktEmail={props.KontaktEmail}
                    onchangeHanelMedArbetare={props.onchangeHanelMedArbetare}
                    isFrom={1}
                    />
                    }
                </div>
                <div className="col-4 "  style={{ margin: 'auto' }}>
                    <HasTeamInput
                     HasOutlook={isUndefined(props.HasOutlook)?1:parseInt(props.HasOutlook)}
                     HasTeam={props.HasTeam}
                     onchangeHandle={props.onchangeHanelHasTeam}
                    />
                </div>
                {
                   
                    parseInt(Flags.canSendSMS) === 1?
                    <>
                    <div className="col-6 my-2"  style={{ margin: 'auto' }}>
                        <TextField
                        variant='outlined'
                        fullWidth
                        label={<IntlMessages id="Tele"/>}
                        value={props.TeleNummer}
                        disabled={parseInt(props.SendNSms) === 0}
                        //error={TeleError}
                        onChange={(e)=>props.onchangeHanelTeleNummer("Tele",e.target.value)}
                        size='small'
                        placeholder={SMSPlaceholder}
                        inputProps={{pattern: "\\+\\d+",}}
                        />
                    </div>
                    <div className="col-6"  style={{ margin: 'auto' }}>
                    <FormControlLabel
                    control={<Switch 
                        size='small'
                        checked={parseInt(props.SendNSms) === 1}
                        name="SendNSms" 
                        onChange={(e)=>props.onchangeHanelSendSms("SendNSms" ,e.target.checked === true?1:0)} 
                    />
                    }
                    label={
                        <Typography variant="body2" sx={{ fontSize: '12px' }}><IntlMessages id="SMS.Notification"/></Typography>
                      }
                    />    
                    </div>                                        
                    </>
                    :""
                }
                <div className="col-12  my-1">
                 <Divider />
                </div>
            </div>
        </div>
    );
}
export default injectIntl(Ansvarig);